export default __webpack_public_path__ + "static/JackieMills-ca1d39327ca33b510bbaae2ded88f9dc.png";